import { IExtractList } from "../redux/Types";

/**
 * Sort Function to sort the extract list
 * extractList - list of extracts to be sorted
 */
export const sortFunction = (extractList: IExtractList[]): IExtractList[] => {
  const data =[...extractList];
  return data?.sort((extract1: IExtractList, extract2: IExtractList) =>
    extract1.extractName?.localeCompare(extract2.extractName));
};
